module.exports = __webpack_public_path__ + "static/i-amplia-estancia-554d11e156d561f137d983daf03c2a10.svg";